import { Button, IconButton } from '@mui/material';
import { styled } from '@mui/system';

export const Pad = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '20px'
});

export const ButtonsWrapper = styled('div')({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '24px'
});

export const KeyButton = styled(Button)({
    width: '72px',
    height: '72px',
    background: '#EDEFF2',
    borderRadius: '48px',
    border: 'none',
    margin: '8px',
    fontSize: '28px',
    fontWeight: 400,
    lineHeight: '41px',
    letterSpacing: '0.25px',
    color: '#000',
    '&:hover': {
        background: '#d0d4d9'
    }
});

export const KeyBoardButton = styled(IconButton)({
    width: '72px',
    height: '72px',
    background: '#0675DD',
    color: '#FFF',
    borderRadius: '48px',
    border: 'none',
    margin: '8px',
    '&:hover': {
        background: '#055cad'
    }
});

export const Message = styled('div')<{ invalidPin: boolean }>(({ theme, invalidPin }) => ({
    display: 'flex',
    marginTop: '20px',
    textAlign: 'center',
    color: invalidPin ? theme.palette.error.main : 'inherit',
    fontWeight: invalidPin ? 500 : 'inherit'
}));

export const PinDisplay = styled('div')({
    display: 'flex',
    marginTop: '16px',
    textAlign: 'center',
    fontSize: '40px',
    fontWeight: 500,
    lineHeight: '48px',
    letterSpacing: '35px',
    minHeight: '48px',
    paddingLeft: '33px'
});
